import { useTranslation } from "react-i18next"

import { LinkButtonHybrid } from "@/components"

import { PartnerCodeDialog } from "./components"
import { usePartnerCodeInput } from "./hooks"

export const PartnerCodeInput = () => {
  const { t } = useTranslation()
  const {
    isDialogOpen,
    code,
    error,
    openDialog,
    closeDialog,
    handleCodeChange,
    submitCode,
  } = usePartnerCodeInput()

  return (
    <>
      <LinkButtonHybrid onClick={openDialog}>
        {t("partnerCode")}
      </LinkButtonHybrid>

      <PartnerCodeDialog
        isOpen={isDialogOpen}
        onClose={closeDialog}
        code={code}
        error={error}
        onCodeChange={handleCodeChange}
        onSubmit={submitCode}
      />
    </>
  )
}
